import { Alert, Button, Text } from '~/shared/ui'
import { useDownloadReport } from '../model'

export function MedistreamReportPage() {
  const { mutate: download, isPending, isSuccess, data, error } = useDownloadReport()

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-6">
      <div className="flex max-w-lg flex-col items-center gap-2 text-center">
        <Text appearance="H6">Medistream Tracking Report</Text>
        <Text
          className="text-text-secondary"
          appearance="BODY2"
        >
          Downloads the full Medistream consignment tracking report as a CSV.
        </Text>
      </div>

      <Button
        onClick={() => download()}
        disabled={isPending}
      >
        {isPending ? 'Preparing…' : 'Download CSV'}
      </Button>

      {isSuccess && (
        <Alert
          // `.material-alert` sets `flex: 1`, which stretches it to fill this
          // flex column's leftover height. `grow-0` keeps it at content height.
          className="grow-0"
          appearance="SUCCESS"
          materialIcon="check_circle"
        >
          {`Downloading report — ${data.recordCount.toLocaleString()} records`}
          {data.generatedDate ? ` from the ${data.generatedDate} snapshot.` : '.'}
        </Alert>
      )}

      {!!error && (
        <Alert
          className="grow-0"
          appearance="ERROR"
          materialIcon="error"
        >
          {error.message || 'Could not prepare the report. Please try again.'}
        </Alert>
      )}
    </div>
  )
}
